<template>
	<!-- https://loading.io/css/ -->
	<div class="lds-dual-ring"></div>
</template>

<script>
	export default {

	}
</script>

<style lang="scss" scoped>
.lds-dual-ring {
  display: inline-block;
  width: 75px;
  height: 75px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 46px;
  height: 46px;
  margin: 1px;
  border-radius: 50%;
  border: 5px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

// custom styles for covering parent div, and making loader more explicit
.lds-dual-ring {
	background-color: rgba(10, 10, 10, 0.5);
  position: fixed; // so it covers whole screen on touch devices
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;
}

@media screen and (min-width: 1024px) {
  .lds-dual-ring {
    position: absolute; // so it only covers main content portion on desktops and larger
  }
}
</style>